import { Container } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';

import styles from './auth-layout.module.css';

export function AuthLayout() {
  return (
    <div className={styles['container']}>
      <div className={styles.header} />
      <Container className={styles.formContainer} size="xs">
        <Outlet />
      </Container>
    </div>
  );
}

export default AuthLayout;
